<template lang="pug">
v-sheet.pa-3.rounded-xl.mb-4(
  v-bind="$attrs"
)
  .grey--text  Шапка договора:
  span(contenteditable @input="firstValue = $event.target.innerText") {{ firstValue }}
  span: strong {{noChangedText}}
  span(contenteditable @input="secondValue = $event.target.innerText") {{ secondValue }}
</template>
<script>
export default {
  props: {
    value: { type: String, default: '' },
    noChangedText: { type: String, default: '«Исполнитель»,' },
  },
  data() {
    return {
      firstValue: '',
      secondValue: '',
      defaultValue: `Федеральное государственное бюджетное учреждение культуры
        «Всероссийский центр развития художественного творчества и гуманитарных технологий»
        (ФГБУК «ВЦХТ»), именуемое в дальнейшем ${this.noChangedText} в лице директора Гончаровой Оксаны Валерьевны,
        действующего на основании Устава`,
    };
  },
  computed: {
    returnValue() {
      return `${this.firstValue} ${this.noChangedText} ${this.secondValue}`;
    },
  },
  watch: {
    returnValue(val) {
      this.$emit('input', val);
    },
  },
  created() {
    const valueToSplit = this.value || this.defaultValue;
    const [first, second] = valueToSplit.split(this.noChangedText);
    this.firstValue = first;
    this.secondValue = second;
  },
  methods: {
    eventM(val) {
      console.log(val.target.innerText);
      console.log(val);
    },
  },
};
</script>
